import { c as _c } from "react/compiler-runtime";
import { CenteredPageContent } from '@/components/Layouts/CenteredPageContent';
import classNames from '@/utils/classNames';
import type { HTMLAttributes } from 'react';
import type { FCC } from 'react-fc';
import styles from './PageActions.module.css';

/**
 * A sticky action bar intended to sit below the PageHeader on article pages.
 */
export const PageActions: FCC<HTMLAttributes<HTMLDivElement>> = t0 => {
  const $ = _c(12);
  let children;
  let className;
  let rest;
  if ($[0] !== t0) {
    ({
      children,
      className,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = rest;
  } else {
    children = $[1];
    className = $[2];
    rest = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = classNames(styles.wrapper, className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== children) {
    t2 = <CenteredPageContent><ul className={styles.list}>{children}</ul></CenteredPageContent>;
    $[6] = children;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== rest || $[9] !== t1 || $[10] !== t2) {
    t3 = <div className={styles.container}><div className={t1} {...rest}>{t2}</div></div>;
    $[8] = rest;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
};
export const PageAction: FCC<{
  primary?: boolean;
} & HTMLAttributes<HTMLLIElement>> = t0 => {
  const $ = _c(12);
  let children;
  let className;
  let rest;
  let t1;
  if ($[0] !== t0) {
    ({
      children,
      className,
      primary: t1,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = rest;
    $[4] = t1;
  } else {
    children = $[1];
    className = $[2];
    rest = $[3];
    t1 = $[4];
  }
  const primary = t1 === undefined ? false : t1;
  let t2;
  if ($[5] !== className || $[6] !== primary) {
    t2 = classNames({
      [styles.primaryAction]: primary
    }, className);
    $[5] = className;
    $[6] = primary;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== children || $[9] !== rest || $[10] !== t2) {
    t3 = <li className={t2} {...rest}>{children}</li>;
    $[8] = children;
    $[9] = rest;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
};